import { render, staticRenderFns } from "./DisplayAmount.vue?vue&type=template&id=4169c2ce"
import script from "./DisplayAmount.vue?vue&type=script&lang=js"
export * from "./DisplayAmount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports